/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Label_PlaceholderInputs */

const en_byoa_label_placeholder = /** @type {(inputs: Byoa_Label_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. My Claude key`)
};

const id_byoa_label_placeholder = /** @type {(inputs: Byoa_Label_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis. Kunci Claude-ku`)
};

/**
* | output |
* | --- |
* | "e.g. My Claude key" |
*
* @param {Byoa_Label_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_label_placeholder = /** @type {((inputs?: Byoa_Label_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Label_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_label_placeholder(inputs)
	return en_byoa_label_placeholder(inputs)
});